export default "__VITE_PUBLIC_ASSET__c1cfd51c__"